import React from 'react'
import { fetchAds } from 'careers/actions/job-ad'
import JobAdList from 'careers/components/job-ad-list'
import FetchWithSpinner from 'components/fetch-with-spinner'
import { useParams } from 'react-router-dom'

/**
 * Careers index page aka job ad listing
 */



function Index() {
  const params = useParams()
  return (
    <FetchWithSpinner action={() => fetchAds(params)}>
      <JobAdList />
    </FetchWithSpinner>
  )
}

export default Index
